export const SIMULATION_TIMING = Object.freeze({
  fixedStepSeconds: 1 / 60,
  maximumCatchUpSteps: 8,
  maximumFrameDeltaSeconds: 0.25,
});
